import {TTenant} from 'src/containers/User/definitions';

import {ESystemNotificationEntityType, TGenericNotification} from './definitions';

type TGenericNews<T, M = TAnyObject> = TGenericNotification<T, M> & {
  entityType: ESystemNotificationEntityType.NEWS;
};

enum ESystemNewsType {
  UpdatePlanned = 'UpdatePlanned',
  WhatsAppLicensePriceUpdatePlanned = 'WhatsAppLicensePriceUpdatePlanned',
  BusinessArticle = 'BusinessArticle',
  BusinessCase = 'BusinessCase',
  MessageMatcherPresetSuggestion = 'MessageMatcherPresetSuggestion',
}

type TReleaseNews = TGenericNews<
  ESystemNewsType.UpdatePlanned,
  {
    startAt: string;
    endAt: string;
  }
>;

type TWhatsAppLicensePriceNews = TGenericNews<ESystemNewsType.WhatsAppLicensePriceUpdatePlanned>;

type TBusinessBlogData = {
  title: string;
  url: string;
  guard?: (data: TTenant) => boolean;
};
type TBusinessArticleNews = TGenericNews<ESystemNewsType.BusinessArticle, TBusinessBlogData>;
type TBusinessCaseNews = TGenericNews<ESystemNewsType.BusinessCase, TBusinessBlogData>;

type TMessageMatcherPresetNews = TGenericNews<
  ESystemNewsType.MessageMatcherPresetSuggestion,
  {subjectNames: string[]}
>;

type TSystemNews =
  | TReleaseNews
  | TWhatsAppLicensePriceNews
  | TBusinessCaseNews
  | TBusinessArticleNews
  | TMessageMatcherPresetNews;

export type {
  TSystemNews,
  TReleaseNews,
  TWhatsAppLicensePriceNews,
  TBusinessCaseNews,
  TBusinessArticleNews,
  TBusinessBlogData,
  TMessageMatcherPresetNews,
};

export {ESystemNewsType};
